export default class EfeedbackSearchPanel {
    constructor() {
        this.attributes = {
            query: 'data-efeedback-search-query',
            initialQuery: 'data-efeedback-search-initial-query'
        };
        this.selectors = {
            main: '[data-efeedback-search-panel]',
            query: `[${this.attributes.query}]`,
            tab: 'efeedback-search-panel__tab',
            tabActive: 'efeedback-search-panel__tab--active',
            tabContent: 'efeedback-search-panel__tab-content',
            tabContentActive: 'efeedback-search-panel__tab-content--active',
            comments: '[data-efeedback-search-panel-comments]',
            ratingBar: 'star-rating-bar',
            ratingBarActive: 'star-rating-bar--active'
        };

        this.query = {};
        this.loading = false;

        this.element = document.querySelector(this.selectors.main);

        this.navigateToPage = this.navigateToPage.bind(this);

        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {
        // early exit
        if (!this.element) {
            return false;
        }

        this.initialQuery = this.element.getAttribute(this.attributes.initialQuery);
        if (!this.initialQuery) {
            return false;
        }

        this.setUpdateQuery(this.getQueryObjectFromQueryString(this.initialQuery));
        this.setEventBindings();
        this.fetchData(this.query, (data) => {
            this.render(this.query, data);
        });
    }

    setEventBindings() {
        this.getQueryElements().forEach((element) => {
            element.addEventListener('click', () => {
                this.onQueryClicked(element);
            });
        });

        this.getCommentsElement().addEventListener('click', (e) => {
            this.onQueryClickedInComments(e.target);
        });

        this.getTabElements()
            .forEach((element, tabIndex) => {
                element.addEventListener('click', () => {
                    this.onTabClicked(tabIndex);
                });
            });

        this.getRatingBarElements()
            .forEach((element) => {
                element.addEventListener('click', () => {
                    this.selectStarBar(element.getAttribute(this.attributes.query));
                });
            });
    }

    onQueryClickedInComments(element) {
        if (element.hasAttribute(this.attributes.query)) {
            this.onQueryClicked(element);
        }
    }

    onQueryClicked(element) {
        const queryString = element.getAttribute(this.attributes.query);
        const queryObject = this.getQueryObjectFromQueryString(queryString);
        this.setUpdateQuery(queryObject);
        this.fetchData(this.query, (data) => {
            this.render(this.query, data);
        });
    }

    selectStarBar(queryAttribute) {
        this.getRatingBarElements()
            .forEach(element =>
                this.toggleElement(
                    element,
                    this.selectors.ratingBarActive,
                    queryAttribute === element.getAttribute(this.attributes.query)));
    }

    onTabClicked(tabIndex) {
        this.getTabElements()
            .forEach((element, index) =>
                this.toggleElement(element, this.selectors.tabActive, tabIndex === index));

        this.getTabContentElements()
            .forEach((element, index) =>
                this.toggleElement(element, this.selectors.tabContentActive, tabIndex === index));
    }

    toggleElement(element, activeClass, isAdditive) {
        if (isAdditive) {
            element.classList.add(activeClass);
        } else {
            element.classList.remove(activeClass);
        }
    }

    getQueryObjectFromQueryString(queryString) {
        const pairs = queryString.split('&');
        const queryObject = {};
        pairs.forEach((pair) => {
            pair = pair.split('=');
            queryObject[pair[0]] = this.getDecodedURIComponent(pair[1] || '');
        });
        return queryObject;
    }

    getDecodedURIComponent(component) {
        return decodeURIComponent(component);
    }

    getQueryStringFromQueryObject(queryObject) {
        return Object.keys(queryObject).map(key => `${key}=${queryObject[key]}`).join('&');
    }

    setUpdateQuery(query) {
        this.query = Object.assign(this.query, query);
    }

    fetchData(queryObject, callback) {
        if (this.loading) {
            return;
        }
        this.loading = true;

        this.selectStarBar(`stars=${queryObject.stars}`);

        let url = `/konten/common/proxy/efeedback-api.php?${this.getQueryStringFromQueryObject(queryObject)}`;

        if (queryObject.product !== 'creditcard') {
            url = queryObject.product;
            if (queryObject.stars && queryObject.stars !== '0') {
                url += `&score=${queryObject.stars}`;
                this.selectStarBar(`stars=${queryObject.stars}`);
            }
        }
        const request = new XMLHttpRequest();
        request.open('GET', url);
        request.setRequestHeader('Content-Type', 'application/json');
        request.onload = () => {
            this.loading = false;
            if (request.status >= 200 && request.status < 300) {
                callback(JSON.parse(request.response));
            } else {
                callback(false);
            }
        };
        request.send();
    }

    setCommentSection(html) {
        this.getCommentsElement().innerHTML = html;
    }

    render(query, data) {
        if (data) {
            this.setCommentSection(data.reportsCaption ? this.getRenderCommentSectionGiro(data) : this.getRenderCommentSection(data));
        }
        this.selectStarBar(`stars=${query.stars || ''}`);
    }

    navigateToPage(url) {
        fetch(url)
            .then(async (response) => {
                const data = await response.json();

                this.render(this.query, data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    getRenderCommentSection(data) {
        return `
            <div class="efeedback-search-panel__comments-title">${data.title}</div>
            <div class="efeedback-search-panel__comments">
                ${data.comments ? data.comments.map(comment => `
                    <div class="efeedback-search-panel__comment">
                        <div class="efeedback-search-panel__comment-header">
                            <div class="efeedback-search-panel__comment-stars">
                                <div class="ekomi__stars">
                                    <div class="ekomi__stars__inactive">
                                        ${Array.from(Array(5)).map(() => '<span class="ekomi__star"></span>').join('')}
                                    </div>
                                    <div class="ekomi__stars__active">
                                        ${Array.from(Array(comment.stars)).map(() => '<span class="ekomi__star ekomi__star--full"></span>').join('')}
                                    </div>
                                </div>${comment.customerName}
                            </div>
                            <div class="efeedback-search-panel__comment-date">${comment.date}</div>
                        </div>
                        <div class="efeedback-search-panel__comment-message" title="${comment.comment}">
                            ${comment.comment}
                        </div>
                    </div>
                `).join('') : ''}
            </div>
            <div class="efeedback-search-panel__comment-controls">
                ${data.prevQuery ? this.getControlToggleElement(data.prevQuery, '« vorherige') : ''}
                ${data.nextQuery ? this.getControlToggleElement(data.nextQuery, 'nächste') : ''}
            </div>
        `;
    }

    getRenderCommentSectionGiro(data) {
        return `
            <div class="efeedback-search-panel__comments-title">${data.reportsCaption}</div>
            <div class="efeedback-search-panel__comments">
                ${data.reports ? data.reports.map(comment => `
                    <div class="efeedback-search-panel__comment">
                        <div class="efeedback-search-panel__comment-header">
                            <div class="efeedback-search-panel__comment-stars">
                                <div class="ekomi__stars">
                                    <div class="ekomi__stars__inactive">
                                        ${Array.from(Array(5)).map(() => '<span class="ekomi__star"></span>').join('')}
                                    </div>
                                    <div class="ekomi__stars__active">
                                        ${Array.from(Array(comment.score)).map(() => '<span class="ekomi__star ekomi__star--full"></span>').join('')}
                                    </div>
                                </div>${comment.customerName}
                            </div>
                            <div class="efeedback-search-panel__comment-date">${comment.date}</div>
                        </div>
                        <div class="efeedback-search-panel__comment-message" title="${comment.comment}">
                            ${comment.comment}
                        </div>
                    </div>
                `).join('') : ''}
            </div>
            <div class="efeedback-search-panel__comment-controls">
                ${data.previousPageUrl ? this.getControlGiroToggleElement(data.previousPageUrl, '« vorherige') : ''}
                ${data.nextPageUrl ? this.getControlGiroToggleElement(data.nextPageUrl, 'nächste') : ''}
            </div>
        `;
    }

    getControlGiroToggleElement(url, text) {
        const uniqueId = `toggle-${Math.random().toString(36).substring(2, 9)}`;

        setTimeout(() => {
            const element = document.getElementById(uniqueId);
            if (element) {
                element.addEventListener('click', () => this.navigateToPage(url));
            }
        }, 0);

        return `<div id="${uniqueId}" class="efeedback-search-panel__comment-toggle">${text}</div>`;
    }

    getControlToggleElement(query, text) {
        return `<div class="efeedback-search-panel__comment-toggle" data-efeedback-search-query="${query}">${text}</div>`;
    }

    getTabElements() {
        return this.getElementArray(this.element.getElementsByClassName(this.selectors.tab));
    }

    getTabContentElements() {
        return this.getElementArray(this.element.getElementsByClassName(this.selectors.tabContent));
    }

    getRatingBarElements() {
        return this.getElementArray(this.element.getElementsByClassName(this.selectors.ratingBar));
    }

    getCommentsElement() {
        return this.element.querySelector(this.selectors.comments);
    }

    getElementArray(elements) {
        return elements ? [...elements] : [];
    }

    getQueryElements() {
        return this.element.querySelectorAll(this.selectors.query);
    }
}
